import {
	get,
	axiosErrorHandler,
	post,
} from 'models/shared/helpers/axiosInstance';
import { buildPathWithQueryParams } from 'models/shared/helpers/utils';
import { PaymentLinkType, PaymentMethodEnum } from '../enums/openpay.enums';
import {
	PaymentLink,
	PaymentLinkFilterDto,
} from '../interfaces/openpay.interface';

export const createPaymentLink = async (
	formId: string,
	type: PaymentLinkType,
	method: PaymentMethodEnum,
	amount?: number,
): Promise<PaymentLink> => {
	try {
		const res = await post(
			`v1/openpay/form/${formId}/payment-link/${type}/${method}`,
			amount !== undefined ? { amount } : undefined,
		);
		return res.data;
	} catch (err: any) {
		throw axiosErrorHandler(err);
	}
};

export const getPaymentLinks = async (dto: PaymentLinkFilterDto) => {
	try {
		const res = await get(
			buildPathWithQueryParams('v1/openpay/payment-links', dto),
		);
		return res.data;
	} catch (err: any) {
		throw axiosErrorHandler(err);
	}
};

export const getPaymentLink = async (id: string) => {
	try {
		const res = await get(`v1/openpay/payment-links/${id}`);
		return res.data;
	} catch (err: any) {
		throw axiosErrorHandler(err);
	}
};

export const sendPaymentLinkEmail = async (id: string): Promise<boolean> => {
	try {
		const res = await post<boolean>(
			`v1/openpay/payment-links/${id}/send-email`,
		);
		return res.data;
	} catch (err: any) {
		throw axiosErrorHandler(err);
	}
};

export const cancelPaymentLink = async (id: string): Promise<PaymentLink> => {
	try {
		const res = await post<PaymentLink>(
			`v1/openpay/payment-links/${id}/cancel`,
		);
		return res.data;
	} catch (err: any) {
		throw axiosErrorHandler(err);
	}
};
